import { render, staticRenderFns } from "./TaxIdTemplate.vue?vue&type=template&id=0fe8e2fd&scoped=true&"
import script from "./TaxIdTemplate.vue?vue&type=script&lang=js&"
export * from "./TaxIdTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe8e2fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fe8e2fd')) {
      api.createRecord('0fe8e2fd', component.options)
    } else {
      api.reload('0fe8e2fd', component.options)
    }
    module.hot.accept("./TaxIdTemplate.vue?vue&type=template&id=0fe8e2fd&scoped=true&", function () {
      api.rerender('0fe8e2fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/TaxIdTemplate.vue"
export default component.exports